import type { Profile } from '@/stores/auth-store'

const DEFAULT_ALLOWED_SUPERADMINS = [
  'soportegorilagym@gmail.com',
  'felipe.ovando@gorilagym.cl',
]

const normalizeEmail = (email: string) => email.trim().toLowerCase()

export function getAllowedPersonalizedPlanSuperAdminEmails() {
  const envValue = import.meta.env.VITE_PERSONALIZED_PLAN_ALLOWED_SUPERADMINS
  const source =
    typeof envValue === 'string' && envValue.trim()
      ? envValue.split(',')
      : DEFAULT_ALLOWED_SUPERADMINS

  return source
    .map(normalizeEmail)
    .filter(
      (email, index, collection) => email && collection.indexOf(email) === index
    )
}

export function canAccessPersonalizedPlanSettings(profile: Profile | null) {
  if (!profile || profile.role !== 'super_admin') {
    return false
  }

  return getAllowedPersonalizedPlanSuperAdminEmails().includes(
    normalizeEmail(profile.email)
  )
}
